import { httpV2 } from "../http";
const entry = (row) => `/survey-board/entries/${row.guest_reservation_id}/${row.survey_id}`;
const data = (request) => request.then((response) => response.data);
const SurveyBoardService = {
  list: (params) => data(httpV2.get("/survey-board", { params })),
  metadata: () => data(httpV2.get("/survey-board/metadata")),
  save: (row, body) => data(httpV2.put(entry(row), body)),
  preview: (row, body) => data(httpV2.post(`${entry(row)}/preview`, body)),
  send: (row, body) => data(httpV2.post(`${entry(row)}/send`, body)),
  history: (row, before) => data(httpV2.get(`${entry(row)}/history`, { params: { before } })),
  response: (row) => data(httpV2.get(`${entry(row)}/response`)),
};
export default SurveyBoardService;
